import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { type INewsModel } from '../types/news'

export interface INewsStoreState {
	latestNews: INewsModel[]
	lastNews: INewsModel[]
}

export interface INewsStore {
	readonly state: {
		latestNews: INewsModel[]
		lastNews: INewsModel[]
	}

	setLatestNews(news: INewsModel[]): void
	fetchLastNews(): Promise<INewsModel[]>
	getLatestNews(): Promise<INewsModel[]>
}

export const useNewsStore = defineStore('newsStore', (): INewsStore => {
	const i18nService = usei18nService()
	const localeLang = i18nService.getLocaleLang()

	const _state = reactive<INewsStoreState>({
		latestNews: [],
		lastNews: [],
	})

	const setLatestNews = (news: INewsModel[]) => {
		_state.latestNews = news
	}

	const fetchLastNews = async () => {
		if (_state.lastNews.length && _state.lastNews.length > 0) {
			return _state.lastNews
		}

		const { data } = await ApiService.fetchNews(1, 10, '', localeLang)

		if (data) {
			_state.lastNews = data
			return _state.lastNews
		}
		return _state.lastNews
	}

	const getLatestNews = async () => {
		if (_state.latestNews.length === 0) {
			try {
				const { data } = await ApiService.fetchNews(1, 4, '', localeLang)

				if (data) setLatestNews(data)
			} catch (error) {
				console.log(error)
			}
		}
		return _state.latestNews
	}

	return {
		state: _state,
		fetchLastNews,
		setLatestNews,
		getLatestNews,
	}
})
